
import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import styles from '../style.module.css';
import AdvantagesItem from './AdvatagesItem';
import langData from "../../../lang/data";

function Advantages() {

    const containerRef = useRef(null);
    const [startAnimation, setStartAnimation] = useState(false);
    const { currentLanguage } = useSelector(({ main }) => main);
    const t = langData.titles;

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setStartAnimation(true);
                    observer.disconnect();
                }
            },
            {
                threshold: 0.3,
            }
        );
        if (containerRef.current) {
            observer.observe(containerRef.current);
        }
        return () => observer.disconnect();
    }, []);


    return (
        <div
            className = {styles.advantages_container}
            ref={containerRef}
        >
            <div className={styles.advantages_contents}>
                <div className={styles.advantages_text_content}>
                    <div className={styles.advantages_text_content_top}>
                        <span>
                            {t.aboutAdvantagesLabel[currentLanguage]}
                        </span>
                        <span>
                            {t.aboutAdvantagesTitle[currentLanguage]}
                        </span>
                    </div>
                    <div className={styles.advantages_text_content_bottom}>
                        {t.aboutAdvantagesText[currentLanguage]}
                    </div>
                </div>
                <div className={styles.advantages_items_box}>
                    <AdvantagesItem
                        value = { '22+' }
                        title = { t.aboutAdvantagesStatYears[currentLanguage] }
                        startAnimation = { startAnimation }
                    />
                    <AdvantagesItem
                        value = { '10000+' }
                        title = { t.aboutAdvantagesStatProducts[currentLanguage] }
                        startAnimation = { startAnimation }
                    />
                    <AdvantagesItem
                        value = { '150+' }
                        title = { t.aboutAdvantagesStatBrands[currentLanguage] }
                        startAnimation = { startAnimation }
                    />
                    <AdvantagesItem
                        value = { '600+' }
                        title = { t.aboutAdvantagesStatEmployees[currentLanguage] }
                        startAnimation = { startAnimation }
                    />
                </div>
            </div>
        </div>
    )
}

export default Advantages;
